import React from 'react';
import { Form, Row, Col, Input, Button, DatePicker } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import moment from 'moment';

const { RangePicker } = DatePicker;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

interface Props extends FormComponentProps {
  getJournalList: (value) => any;
  setSearchValue: (value) => void;
}

const FormList = (props: Props) => {
  const { getFieldDecorator } = props.form;

  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      console.log(values)
      if (!err) {
        let startTime = values.times ? moment(values.times[0]).valueOf() : undefined;
        let endTime = values.times ? moment(values.times[1]).valueOf() : undefined;
        values.page = 1,
        values.size = 10,
        values.times =  [startTime, endTime]
        props.setSearchValue({
          userName: values.userName,
          times: values.times
        })
        props.getJournalList(values)
      }
    });
  }

  const handleResetClick = () => {
    props.setSearchValue({
      userName: null,
      times: null
    })
    props.form.resetFields()
  };

  return (
    <div style={{paddingBottom: 40}}>
      <Row gutter={24}>
        <Form {...formItemLayout} onSubmit={handleSubmit}>
          <Col span={8}>
            <Form.Item label="用户名">
              {getFieldDecorator('userName', {
                // rules: [{ required: true, message: '车架号!' }],
              })(
                <Input placeholder="请输入" />
              )}
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="操作时间">
              {getFieldDecorator('times', {
                // rules: [{ required: true, message: '车架号!' }],
              })(
                <RangePicker
                  showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  // placeholder={['Start Time', 'End Time']}
                  // onChange={onChange}
                  // onOk={onOk}
                  style={{width: '100%'}}
                />
              )}
            </Form.Item>
          </Col>

          <Col offset={16} xxl={{ offset: 18 }}>
            <Button type="primary" style={{ marginRight: 30 }} htmlType="submit">查询</Button>
            <Button type="default" style={{ marginRight: 30 }} onClick={handleResetClick}>重置</Button>
          </Col>

        </Form>
      </Row>
    </div>
  )
}

let newFormList: any = Form.create()(FormList)

export default newFormList